export default {
  haulers: 'Transportatori',
  setup: 'Configurare',
  driverExperience: 'Experiența șoferului',
  users: 'Utilizatori',
};
